module.exports = __webpack_public_path__ + "img/ic_inventory.3901cd6d.png";